// Thème Fluent UI v9 - on réutilise simplement le thème web "light" par défaut.
// Outlook web pousse déjà un styling Fluent ; on garde donc le thème natif pour
// rester cohérent.
import { webLightTheme, Theme } from "@fluentui/react-components";

export const appTheme: Theme = webLightTheme;
